import styles from './ui-menu-column.css';
import { Children } from '../../../decorators/child.decorator';
import { Component } from '../../../decorators/component.decorator';
import { UIElement } from '../../ui-element';
import { UIMenuGroup } from './ui-menu-group';
import { Attribute } from '../../../decorators/attribute.decorator';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIMenuColumn
 * @element ui-menu-column
 * @classdesc Represents a class for <code>ui-menu-column</code> element.
 * Sets menu group placement for both desktop and mobile. Should be used inside <code>ui-menu-tab</code> element.
 * @property {boolean} [active] {@attr active} Marks this menu column as active.
 * @property {NodeListOf<UIMenuGroup>} [menuGroups] Get menu groups.
 * @example
 * <ui-menu-column>
 *   <ui-menu-group label="Group 1">
 *     <ui-menu-link>Item 1</ui-menu-link>
 *     <ui-menu-link>Item 2</ui-menu-link>
 *   </ui-menu-group>
 *   <ui-menu-group label="Group 2">
 *     <ui-menu-link>Item 3</ui-menu-link>
 *     <ui-menu-link>Item 4</ui-menu-link>
 *   </ui-menu-group>
 * </ui-menu-column>
 */
@Component({
    tag: 'ui-menu-column',
    styles,
})
export class UIMenuColumn extends UIElement {
    @Attribute(Boolean) active?: boolean;
    @Children('ui-menu-group') menuGroups!: Array<UIMenuGroup>;
}
